import PropTypes from 'prop-types';

import BrDropdownMenu from '@components/BrDropdownMenu';
import BrIcons from '@components/BrIcons';
import ColorStyles from '@components/ColorStyles';

export default function ActionsColumn({ row, col }) {
  const { validActions } = row;

  function filterByValidActions(item) {
    const key = item.value;
    return !!validActions[key];
  }

  const displayItems = Object.values(col.columnConfig.optionsList).filter(filterByValidActions);

  return (
    <div className="br-table-actions-column">
      <BrDropdownMenu
        title={(
          <div className="manage-title">
            {col.columnConfig.titleText || 'Manage'}
            <BrIcons.DownCaret colorStyle={ColorStyles.BLUE} isSubComp />
          </div>
        )}
        className="action-button"
        useBtnStyle
        btnColorStyle={ColorStyles.BLUE}
        selected={{}}
        onSelect={(value) => col.columnConfig.onClick(value, row)}
        items={displayItems}
      />
    </div>
  );
}

ActionsColumn.propTypes = {
  cell: PropTypes.shape({
    // cell data
    value: PropTypes.any,
  }).isRequired,
  col: PropTypes.shape({
    // column config
    columnConfig: PropTypes.shape({
      onClick: PropTypes.func.isRequired, // (row, value:type) :=> {}
      onDelete: PropTypes.func.isRequired,
      optionsList: PropTypes.any,
      titleText: PropTypes.string,
    }).isRequired,
  }).isRequired,
  row: PropTypes.shape({
    Original_Data: PropTypes.shape({
      id: PropTypes.any,
      name: PropTypes.any,
      type: PropTypes.any,
      isEditable: PropTypes.any,
    }).isRequired,
  }).isRequired,
};
